import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export function useFavorites() {
  const { user } = useAuth();
  const [ids, setIds] = useState({ job: [], usta: [] });

  const load = useCallback(() => {
    if (user && user.id) {
      api.get("/favorites/ids").then(({ data }) => setIds(data)).catch(() => {});
    }
  }, [user]);

  useEffect(() => { load(); }, [load]);

  const toggle = useCallback(async (itemType, itemId) => {
    if (!user || !user.id) { toast.error("Favorilere eklemek için giriş yapın"); return; }
    try {
      const { data } = await api.post("/favorites", { item_type: itemType, item_id: itemId });
      setIds((prev) => {
        const arr = prev[itemType] || [];
        const next = data.favorited ? [...arr, itemId] : arr.filter((x) => x !== itemId);
        return { ...prev, [itemType]: next };
      });
      toast.success(data.favorited ? "Favorilere eklendi" : "Favorilerden çıkarıldı");
    } catch { toast.error("İşlem başarısız"); }
  }, [user]);

  const isFav = useCallback((itemType, itemId) => (ids[itemType] || []).includes(itemId), [ids]);

  return { ids, isFav, toggle };
}
